import { render, staticRenderFns } from "./SchattingView.vue?vue&type=template&id=4815c6a5"
import script from "./SchattingView.vue?vue&type=script&lang=js"
export * from "./SchattingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports